import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  CardGroup,
  Card,
  CardBody,
  Button,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText
} from "reactstrap";
import AuthService from "../../../components/AuthService";
import { ToastContainer, toast } from "react-toastify";
import ContentLoader from "react-content-loader";
class ForgottenPassword extends Component {
  constructor() {
    super();
    this.handleChange = this.handleChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.handleLogin = this.handleLogin.bind(this);
    this.Auth = new AuthService();
    this.state = { emailVerif: false };
  }
  validateEmailField(value) {
    if (value == null) {
      return false;
    }
    return value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
  }

  notifyError(err) {
    toast.error(err);
  }

  notifySuccess(msg) {
    toast.success(msg);
  }

  handleLogin(e) {
    e.preventDefault();
    this.props.history.replace("/login");
  }

  handleFormSubmit(e) {
    e.preventDefault();
    if (!this.state || !this.state.emailVerif) {
      this.notifyError(
        "Veuillez reessayer. Les informations entrées ne sont pas correctes ou manquantes."
      );
      return;
    }
    this.setState({ loading: true });
    this.Auth.httpRequest("GET", "passwordForgotten/" + this.state.email)
      .then(res => {
        this.setState({ loading: false });
        this.props.history.replace("/login");
        this.notifySuccess(
          "Tu peux surveiller tes mails, tu vas en recevoir un !"
        );
      })
      .catch(err => {
        this.setState({ loading: false });
        this.notifyError(
          "Ton token est déjà généré ou l'adresse mail est introuvable"
        );
      });
  }

  handleChange(e) {
    if (e.target.name == "email") {
      e.target.value = e.target.value.trim();
    }
    this.setState({
      [e.target.name]: e.target.value
    });
    if (e.target.name == "email" && this.validateEmailField(e.target.value)) {
      this.setState({ emailVerif: true });
    } else {
      this.setState({ emailVerif: false });
    }
  }

  componentWillMount() {}

  componentDidMount() {
    this.setState({});
  }

  render() {
    let content, loading, style;
    if (!this.state) {
      content = (
        <ContentLoader
          height={200}
          width={400}
          speed={2}
          primaryColor={"#f3f3f3"}
          secondaryColor={"#ecebeb"}
        >
          <rect x="7" y="17" rx="4" ry="4" width="126.36" height="11.14" />
          <rect x="11" y="33.9" rx="3" ry="3" width="107.1" height="11.26" />
          <rect x="3" y="58" rx="3" ry="3" width="385" height="28.48" />
          <rect x="3" y="95" rx="3" ry="3" width="385" height="28.48" />
          <rect x="9" y="143.9" rx="0" ry="0" width="105" height="24" />
          <rect x="310" y="153.9" rx="0" ry="0" width="78" height="9" />
        </ContentLoader>
      );
    } else {
      if (this.state.loading) {
        loading = (
          <img
            src="/img/loading_icon.gif"
            style={{
              height: "auto",
              width: "auto",
              maxWidth: 70 + "px",
              maxHeight: 70 + "px"
            }}
          />
        );
      }
      if (this.state.emailVerif) {
        style = { borderColor: "green" };
      }
      content = (
        <CardBody>
          <h1>Tableau de bord Happy Quest</h1>
          <p className="text-muted">Mot de passe oublié ?</p>
          <InputGroup className="mb-3">
            <InputGroupAddon addonType="prepend">
              <InputGroupText>
                <i className="fa fa-user" />
              </InputGroupText>
            </InputGroupAddon>
            <Input
              placeholder="Saisissez votre email"
              name="email"
              type="text"
              onChange={this.handleChange}
              id="email"
              style={style}
              required
            />
          </InputGroup>
          <Row>
            <Col xs="6">
              <Button
                id="submit"
                color="primary"
                className="px-4"
                onClick={this.handleFormSubmit}
                block
              >
                Récupérer mon mot de passe
              </Button>
              {loading}
            </Col>
            <Col xs="6" className="text-right">
                <Button
                  id="login"
                  color="link"
                  className="px-0"
                  onClick={this.handleLogin}
                >
                  Se connecter
                </Button>
            </Col>
          </Row>
        </CardBody>
      );
    }
    return (
      <div className="app flex-row align-items-center">
        <ToastContainer />
        <Container>
          <Row className="justify-content-center">
            <Col md="8">
              <CardGroup>
                <Card className="p-4">{content}</Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default ForgottenPassword;



// WEBPACK FOOTER //
// ./src/views/Pages/ForgottenPassword/ForgottenPassword.js